import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
// GymHome is the landing route — needed on virtually every cold entry, so it
// ships in the main bundle (NOT lazy) and renders directly with the shell.
// No <Suspense> wraps it: it's local-first (SQLite reads resolve in ~50ms) and
// its queries are non-suspending, so a fallback would only flash + cause a
// remount.
import { GymHome } from "@/features/gym/components/gym-home";

function HomePage() {
  return <GymHome />;
}

export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  component: HomePage,
});
